import { ChangeDetectorRef, Component, ElementRef, Input } from '@angular/core';
import { HelperModule } from '../../modules/helper.module';
import { MatDialog } from '@angular/material/dialog';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { SharedService } from '../../modules/shared-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import config from 'config/default.json';
import { FormControl } from '@angular/forms';
import { ActivityDetailsComponent } from './activity-details/activity-details.component';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs';
import Chart, { ChartConfiguration } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.scss']
})
export class ManagementComponent {
  constructor(
      private elRef:ElementRef,
      public cdRef: ChangeDetectorRef,
      public helper: HelperModule,
      public dialog: MatDialog,
      private apiService: ApiServiceModule,
      private sharedService: SharedService,
      public sanitizer: DomSanitizer) {
    }
    @Input() userInfos: { [x:string]: any } = new Map();
    chartEvolution: Chart | null = null;
    categories :any[] = [];
    taskStatus:any[] = [];
    taskPriorities : any[] = [];
    expenseStatus:any[] = [];
    expenseCoverage :any[] = [];

    expensesData:any[] = [];
    tasksData: any[] = [];
    subscriptionData:any[] = [];

    startDateInputControl = new FormControl();
    endDateInputControl = new FormControl();
    usersControl = new FormControl();
    userSearchControl = new FormControl();

    showFilters = false;
    mobileTabs: any;
    activityColumns: any;
    inProgress:boolean = false;
    categoriesControl = new FormControl();
    statusControl = new FormControl();
    users:any[] = [];
    waves:{[x: string]: any}[] = [];
    
    usersSelected: any[] = [];

    totalSubscription:string = '0 XOF';
    totalExpense:string = '0 €';
    expensesIncomesStats: any[] = [];
    monthSubscription:string = '0 XOF';
    monthExpense:string = '0 €';

    subscriptionActivityAmount:string = '0 XOF';
    expenseActivityAmount:string = '0 €';
    taskInProgress:number = 0;

    tasksStats: any;
    
    ngOnInit(){
      this.userSearchControl.valueChanges.pipe(
      filter(query => query && query.length > 2),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((query) => {
        return this.apiService.queryData(config.master.ndapi.url+'/enovsky/web/administration/search_user', {search_key: query}, this.userInfos['access_token'])
      })).subscribe((options) => {
      this.users = options;
    });
      
    }
    ngAfterViewInit(){
      this.loadManagement();
      this.loadActivities();
    }
    loadManagement(){
      this.inProgress = false;
      this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/management/load_management', {}, this.userInfos['access_token']).subscribe((response: any)=>{
        this.waves = response['waves'];
        this.users = response['users'];
        this.categories = response['categories'];
        this.taskStatus = response['task_status']; 
        this.taskPriorities = response['task_priorities'];
        this.expenseStatus = response['expense_status'];
        this.expenseCoverage = response['expense_coverages'];
        this.expensesIncomesStats = response['expenses_incomes_stat'];
        this.tasksStats = response['tasks_stat'][0];

        this.monthSubscription = this.convertToAmount(Math.floor((this.expensesIncomesStats?.[0]?.income_price || 0) * 100) / 100) + ' XOF';
        this.monthExpense = this.convertToAmount(Math.floor((this.expensesIncomesStats?.[0]?.expense_euro || 0) * 100) / 100) + ' €';

        this.totalSubscription = this.convertToAmount(Math.floor(this.expensesIncomesStats.slice(0, this.expensesIncomesStats.findIndex((el:any) => el.year_month.startsWith('09-') ) + 1).reduce((total: number, element: any) => total + Number(element.income_price || 0),0) * 100)/100) + ' XOF';
        this.totalExpense = this.convertToAmount(Math.floor(this.expensesIncomesStats.slice(0, this.expensesIncomesStats.findIndex((el:any) => el.year_month.startsWith('09-') ) + 1).reduce((total: number, element: any) => total + Number(element.expense_euro || 0),0) * 100)/100) + ' €';
        this.inProgress = false;
        this.drawActivityEvolution();
        this.helper.showToast("Data refreshed...");
      })
    }
    convertToAmount(amount:number){
      return new Intl.NumberFormat('fr-FR').format(amount).replace(/\u202f|\u00a0/g, ' ')
    }
    loadActivities(){
      let startDate: any = this.formatDate(this.startDateInputControl.value);
      let endDate:any = this.formatDate(this.endDateInputControl.value)?.replace('00:00:00', '23:59:59')

      let dates:any = [startDate, endDate];
      dates = dates.filter((el:any) => el != null);
      dates = dates.length > 1? dates: (dates.length == 1? [dates[0], dates[0]]: null);
    
      let data = {
        id_user: this.userInfos['id_user'], 
        id_categories: this.categoriesControl.value,
        id_status: this.statusControl.value,
        id_users: this.usersControl.value,
        privilege: this.userInfos['privilege'],
        dates: dates,
      }
      this.inProgress = false;
      this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/management/load_activity', data, this.userInfos['access_token']).subscribe((response: any)=>{
        this.expensesData = response['expenses'];
        this.tasksData = response['tasks'];
        this.subscriptionData = response['subscriptions'];
        this.subscriptionActivityAmount = this.convertToAmount(Math.floor(this.subscriptionData.reduce((total: number, element: any) => total + Number(element.payment_price || 0),0) * (1 - 0.025) * 100)/100)+' XOF';
        this.taskInProgress = this.tasksData.filter((task:any) => task.status_key !== 'done').length;
        this.expenseActivityAmount = this.convertToAmount(Math.floor(this.expensesData.reduce((total: number, element: any) => total + Number(element.amount_euro || 0),0) * 100) / 100)+ ' €';

        this.inProgress = false;
        this.setUpView();
        this.helper.showToast("Data refreshed...");
      })
    }
    
    openActivity(activity:string, rowInfos:any = null){
      let mode = rowInfos? (['paid', 'done'].includes(rowInfos.status_key)? 'view': 'edit'): 'create';
      
      const dialogRef = this.dialog.open(ActivityDetailsComponent, {
          width: '1100px',
          maxWidth: '96vw',
          height: '92dvh',
          maxHeight: '92dvh',
          panelClass: 'task-details-dialog',
          autoFocus: false,
          restoreFocus: false,
          data: {activity: activity, mode: mode, 
            users: this.users, categories: this.categories, task_status: this.taskStatus, task_priorities: this.taskPriorities, expense_status: this.expenseStatus, expense_coverages: this.expenseCoverage,
            waves: this.waves, user_infos: this.userInfos, row_infos: rowInfos}
        });
        dialogRef.afterClosed().subscribe((response:any) => {
      });
    }
    formatDate(date: any) {
      const d = new Date(date);
      return date != null? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} 00:00:00`: null;
    }
    setUpView(){
      this.mobileTabs = this.elRef.nativeElement.querySelectorAll('.mobile-tab');
      this.activityColumns = this.elRef.nativeElement.querySelectorAll('.activity-column');
      
      this.mobileTabs.forEach((tab:any) => tab.addEventListener('click', () => this.activateTab(tab.dataset.target)));
       
      window.addEventListener('resize', this.syncResponsiveView);
      this.syncResponsiveView();
    }
    drawActivityEvolution() {
      this.chartEvolution = new Chart(this.elRef.nativeElement.querySelector('.activity-evolution'), {
          type: 'line',
          data: {
              labels: this.expensesIncomesStats.map(el => el.month_label).reverse(),
              datasets: [{
                  label: 'Encaissements',
                  data: this.expensesIncomesStats.map(el => el.income_price).reverse(),
                  fill: false,
                  backgroundColor: '#36A2EB',
                  borderColor: '#36A2EB',
                  borderWidth: 2,
                  pointRadius: 2,
                  tension: 0.3
              }, {
                  label: 'Dépenses',
                  data: this.expensesIncomesStats.map(el => el.expense_cfa).reverse(),
                  fill: false,
                  backgroundColor: '#FF6384',
                  borderColor: '#FF6384',
                  borderWidth: 2,
                  pointRadius: 2,
                  tension: 0.3
              }]
          },
          options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                  legend: {
                      position: 'bottom',
                      labels: {
                          usePointStyle: true,
                          boxWidth: 8,
                          padding: 15,
                          font: { size: 11 }
                      }
                  },
                  datalabels: { display: false }
              },
              scales: {
                  x: {
                      title: { display: true, text: 'Mois' },
                      ticks: {
                          autoSkip: true,
                          maxTicksLimit: 5,
                          maxRotation: 0,
                          minRotation: 0,
                          font: { size: 10 }
                      }
                  },
                  y: {
                      title: { display: true, text: 'Montant' },
                      beginAtZero: true,
                      ticks: { font: { size: 10 } }
                  }
              }
          }
      });
  }
    get selectedFilterUsers(): any {
      const ids = this.usersControl.value ?? [];
      return this.users.filter(user => ids.includes(user.id)).map(user => user.first_name).join(', ');
    }
    selectedElement(selectedOptions: FormControl, element: { [x:string]: string|number|boolean }): boolean {
      return Array.isArray(selectedOptions.value) && selectedOptions.value.includes(element['id']);
    }
    resetDate(){
      this.startDateInputControl.setValue(null);
      this.endDateInputControl.setValue(null);
    }
    activateTab(target:any) {
        this.mobileTabs.forEach((tab:any) => tab.classList.toggle('active', tab.dataset.target === target));
        this.activityColumns.forEach((column:any) => column.classList.toggle('mobile-active', column.id === target));
      }
    syncResponsiveView(){
      if (window.innerWidth > 700) this.activityColumns.forEach((column:any) => column.classList.add('mobile-active'));
      else {
        const active = this.elRef.nativeElement.querySelector('.mobile-tab.active')?.dataset.target || 'expenses';
        this.activateTab(active);
      }
    }
}
